<div fxLayoutGap="10px" class="status-filters">
  <mat-radio-group aria-label="Select an option" [formControl]="selectedFilter" fxLayout.xs="column" fxLayoutGap.xs="3px">
      <ng-container *ngFor="let status of statusFilters">
        <mat-radio-button [value]="status?.value">{{status?.label | translate}}</mat-radio-button>
      </ng-container>
  </mat-radio-group>
</div>
